// src/index.js
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Box, CircularProgress } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './components/queryClient';
import { router } from './router';
import './polyfills/cryptoRandomUUID';
import { LicenseInfo } from '@mui/x-license';
import { ColorModeProvider } from './theme/ColorModeProvider';

config({ licenseKey });
LicenseInfo.setLicenseKey('85a3b5b51968947e07007626dec240e3Tz0xMjQ2NjEsRT0xODAwNzQ4Nzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y');

const root = createRoot(document.getElementById('root'));

const PageFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
    <CircularProgress />
  </Box>
);

root.render(
  //  <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <ColorModeProvider>
      <Suspense fallback={<PageFallback />}>
        <RouterProvider router={router} />
      </Suspense>
    </ColorModeProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
